import "./App.scss";
import { lazy, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "./components/common/Layout";
import Login from "./components/common/Login/Login";
import SessionTimeout from "./components/SessionTimeout/index";
import { useDispatch, useSelector } from "react-redux";
import { logout, login } from "./store/authslice";
import { setToastMessage } from "./store/toasterslice";
import Toast from "./components/common/Toast";
import { RootState } from "./store/store";
import buildVersion from "./buildVersion.json";
const Details = lazy(() => import("./modules/device-details/index"));
// const Dashboard = lazy(() => import("./modules/device-overview/index"));
const Dashboard = lazy(() => import("./modules/deviceOverViewNew/Dashboard"));
const PortForwarding = lazy(() => import("./modules/portforwarding"));
const ModbusClient = lazy(() => import("./modules/modbusclient/index"));
const DataBackfill = lazy(() => import("./modules/data-backfill/index"));
const AccountManagement = lazy(() => import("./modules/account-management"));
const appBuildVersion =
  process.env.REACT_APP_BUILD_VERSION || buildVersion.version;

const App = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(
    (state: RootState) => state.auth.isLoggedIn,
  );
  const toastMessage = useSelector((state: RootState) => state.toastMessage);

  useEffect(() => {
    document.title = `RDM Application - Build v${appBuildVersion}`;
  }, []);

  // Sync Redux login state from localStorage
  useEffect(() => {
    const userData = localStorage.getItem("loginemail");
    if (userData) {
      try {
        const parsed = JSON.parse(userData);
        if (parsed?.email) {
          dispatch(login(parsed?.email));
        }
      } catch {
        // Fallback if plain string was stored earlier
        dispatch(login(userData));
      }
    }
  }, [dispatch]);

  const handleLogout = async () => {
    //const logOutUrl = await getLogoutUrlFromApi();
    const logOutUrl = process.env.REACT_APP_LOGOUT_URL; //Temporary fix
    dispatch(logout());
    localStorage.clear();
    if (logOutUrl) window.location.assign(logOutUrl);
  };

  const routesConfig = [
    { path: "/", element: <Dashboard />, index: true },
    { path: ":customerId", element: <Dashboard /> },
    { path: "/details/:id", element: <Details /> },
    { path: "port-forwarding", element: <PortForwarding /> },
    { path: "modbus-client", element: <ModbusClient /> },
    { path: "ethernet-config", element: <ModbusClient /> },
    { path: "data-backfill", element: <DataBackfill /> },
    { path: "account-management", element: <AccountManagement /> },
    { path: "*", element: <div>Page Not Found</div> },
  ];

  return (
    <>
      <Toast
        visible={toastMessage?.visible}
        message={toastMessage?.message}
        type={toastMessage?.type}
        onClose={() =>
          dispatch(
            setToastMessage({
              message: "",
              type: "",
              visible: false,
            }),
          )
        }
      />
      <Routes>
        <Route
          path="/"
          element={
            isAuthenticated ? (
              <>
                <SessionTimeout onLogout={handleLogout} />
                <Layout onLogout={handleLogout} />
              </>
            ) : (
              <Login
                onLogin={() => {
                  const email = localStorage.getItem("loginemail") || "";
                  dispatch(login(email));
                }}
              />
            )
          }
        >
          {routesConfig.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={route.element}
              index={route.index || false}
            />
          ))}
        </Route>
      </Routes>
    </>
  );
};

export default App;
